<script setup lang="ts">
import { useId } from 'vue'
import raldoMark from '../../../assets/brand/raldo-mark.svg?raw'

const glyph = raldoMark.replace(/^[\s\S]*?<svg[^>]*>|<\/svg>\s*$/g, '')
const filterId = `mark-relief-${useId()}`
</script>

<template>
  <svg class="mark-relief" viewBox="0 0 129 129" aria-hidden="true" focusable="false">
    <defs>
      <filter
        :id="filterId"
        x="-15%"
        y="-15%"
        width="130%"
        height="130%"
        color-interpolation-filters="sRGB"
      >
        <feComponentTransfer in="SourceAlpha" result="solid">
          <feFuncA type="linear" slope="200" />
        </feComponentTransfer>
        <feOffset in="solid" dy="2.4" result="down" />
        <feGaussianBlur in="down" stdDeviation="2.16" result="downBlur" />
        <feComposite in="solid" in2="downBlur" operator="out" result="topEdge" />
        <feFlood class="mark-relief__shade" />
        <feComposite in2="topEdge" operator="in" result="shade" />
        <feOffset in="solid" dy="-2.4" result="up" />
        <feGaussianBlur in="up" stdDeviation="2.16" result="upBlur" />
        <feComposite in="solid" in2="upBlur" operator="out" result="bottomEdge" />
        <feFlood class="mark-relief__light" />
        <feComposite in2="bottomEdge" operator="in" result="light" />
        <feOffset in="solid" dy="1.44" result="lipShift" />
        <feComposite in="lipShift" in2="solid" operator="out" result="lipEdge" />
        <feGaussianBlur in="lipEdge" stdDeviation="0.25" result="lipSoft" />
        <feFlood class="mark-relief__lip" />
        <feComposite in2="lipSoft" operator="in" result="lip" />
        <feMerge>
          <feMergeNode in="SourceGraphic" />
          <feMergeNode in="shade" />
          <feMergeNode in="light" />
          <feMergeNode in="lip" />
        </feMerge>
      </filter>
    </defs>
    <g :filter="`url(#${filterId})`" v-html="glyph" />
  </svg>
</template>
